import { makeStyles } from '@material-ui/core';

export const useBulkEmailSequencesPreviewItemStyles = makeStyles(theme => ({
  divider: {
    height: 2
  },
  sectionTitleContainer: {
    padding: theme.spacing(0, 3, 1, 3)
  },
  statsButton: {
    marginRight: theme.spacing(1)
  }
}));
